export default function VPNService() {
  return (
    <section id="vpn-service" className="py-32 bg-gradient-to-br from-purple-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-6">Our VPN Service</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Experience unparalleled security and privacy with our state-of-the-art VPN technology designed to keep you safe online.
          </p>
        </div>

        <div className="max-w-5xl mx-auto bg-white rounded-3xl shadow-xl p-12">
          <div className="flex justify-center mb-12">
            <div className="w-32 h-32 bg-gradient-to-br from-purple-500 to-blue-600 rounded-full flex items-center justify-center shadow-2xl">
              <i className="ri-global-line text-6xl text-white"></i>
            </div>
          </div>

          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-6">Enterprise-Grade Security for Everyone</h3>
            <p className="text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto">
              Our VPN service uses military-grade encryption to secure your internet connection, protecting your data from hackers, ISPs, and government surveillance. With servers strategically located around the globe, you can access content from anywhere while maintaining lightning-fast connection speeds. We never log your activity, ensuring complete anonymity and privacy.
            </p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="bg-purple-50 rounded-xl p-6 text-center border border-purple-100">
              <div className="w-12 h-12 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <p className="text-sm font-bold text-purple-900">256-bit Encryption</p>
            </div>
            <div className="bg-purple-50 rounded-xl p-6 text-center border border-purple-100">
              <div className="w-12 h-12 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-earth-line text-2xl text-white"></i>
              </div>
              <p className="text-sm font-bold text-purple-900">Global Servers</p>
            </div>
            <div className="bg-purple-50 rounded-xl p-6 text-center border border-purple-100">
              <div className="w-12 h-12 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-eye-off-line text-2xl text-white"></i>
              </div>
              <p className="text-sm font-bold text-purple-900">Zero Logs Policy</p>
            </div>
            <div className="bg-purple-50 rounded-xl p-6 text-center border border-purple-100">
              <div className="w-12 h-12 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-speed-line text-2xl text-white"></i>
              </div>
              <p className="text-sm font-bold text-purple-900">Unlimited Bandwidth</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
